import { BasketItem, IBasket, IBasketData, IBasketItem, IProductData } from "@/entities";
import { IBasketRepository } from "@/repositories/basket";
import { IBasketService } from "./basket.types";

// export const defaultBasket: IBasket = new Basket({
//     basketId: "",
//     basketName: "",
//     ownerId: "",
//     productList: [],
//     branchId: "any"
// });

export class BasketService implements IBasketService {
    constructor(private repository: IBasketRepository) {}

    async getBasketById(
        basketID: string,
        saleID: string,
        apikey: string
    ): Promise<IBasket | undefined> {
        return this.repository.getBasket(basketID, apikey);
    }

    async createBasket(
        basketData: IBasketData,
        apikey: string
    ): Promise<IBasket> {
        return this.repository.createBasket(
            basketData.basketId!,
            basketData.ownerId,
            apikey
        );
    }

    async syncBasket(
        basketData: IBasketData,
        apikey: string
    ): Promise<IBasket> {
        try {
            const basket = await this.getBasketById(
                basketData.basketId!,
                basketData.ownerId,
                apikey
            );
            if (basket) {
                return basket;
            }
            throw new Error("construct basket class error");
        } catch (error: any) {
            if (error.message.includes("basket doesnt exist")) {
                return await this.createBasket(basketData, apikey);
            }
            throw error;
        }
    }

    async addProduct(basketID: string, data: IProductData, apikey: string): Promise<IBasket> {
        const item: BasketItem = {
            sku: data.cprcode,
            quantity: 1,
        }
        return this.repository.addBasket(basketID, item, apikey);
    }


    async incrementProduct(basketID: string, data: IProductData, apikey: string): Promise<IBasket> {
        const item: BasketItem = {
            sku: data.cprcode,
            quantity: 1,
        }
        return this.repository.addBasket(basketID, item, apikey);
    }

    async decrementProduct(basketID: string, data: IProductData, apikey: string): Promise<IBasket> {
        const item: BasketItem = {
            sku: data.cprcode,
            quantity: -1,
        }
        return this.repository.addBasket(basketID, item, apikey);
    }

    async updateProduct(basketID: string, data: IProductData, quantity: number, apikey: string): Promise<IBasket> {
        const item: BasketItem = {
            sku: data.cprcode,
            quantity,
        }
        return this.repository.addBasket(basketID, item, apikey);
    }

    async clear(basketID: string, apikey: string): Promise<IBasket> {
        return this.repository.emptyBasket(basketID, apikey);
    }

}
